import * as React from "react";
import { type SVGProps } from "react";
const SvgVisa = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={38}
    height={26}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x={0.5}
      y={0.5}
      width={37}
      height={25}
      rx={4.5}
      fill="#fff"
      stroke="#DBE3EB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.536 17.613H9.234l-1.726-6.571c-.082-.303-.256-.57-.512-.696a7.503 7.503 0 0 0-2.11-.695v-.253h3.708c.512 0 .896.38.96.821l.896 4.74 2.3-5.561h2.239l-3.453 8.215Zm4.732 0h-2.174l1.79-8.215h2.174l-1.79 8.215Zm4.603-5.94c.064-.442.448-.695.896-.695a4.058 4.058 0 0 1 2.11.38l.384-1.77a5.514 5.514 0 0 0-1.982-.38c-2.11 0-3.646 1.138-3.646 2.718 0 1.201 1.088 1.832 1.856 2.212.83.379 1.15.632 1.086 1.01 0 .57-.64.822-1.278.822-.768 0-1.536-.19-2.238-.506l-.384 1.77c.767.316 1.598.443 2.366.443 2.366.062 3.836-1.075 3.836-2.781 0-2.149-3.006-2.275-3.006-3.222Zm10.615 5.94-1.727-8.215h-1.854a.962.962 0 0 0-.896.632l-3.196 7.583h2.238l.447-1.2h2.75l.255 1.2h1.983Zm-3.26-6.003.638 3.096h-1.79l1.151-3.096Z"
      fill="#172B85"
    />
  </svg>
);
export default SvgVisa;
